<div class="loading-container">
    <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
</div>
